import Search from './SearchBar';
import './SearchBar.less'

export default Search
